import AsyncSelect from './AsyncSelect';
import Checkbox from './Checkbox';
import CommonSelect from './CommonSelect';
import Datepicker from './Datepicker';
import Errors from './Errors';
import Form from './Form';
import Hidden from './Hidden';
import MultiFieldValidation from './MultiFieldValidation';
import Password from './Password';
import Radio from './Radio';
import Select from './Select';
import Text from './Text';
import TextArea from './TextArea';
export default {
  AsyncSelect: AsyncSelect,
  Checkbox: Checkbox,
  CommonSelect: CommonSelect,
  Datepicker: Datepicker,
  Errors: Errors,
  Form: Form,
  MultiFieldValidation: MultiFieldValidation,
  Password: Password,
  Radio: Radio,
  Select: Select,
  Text: Text,
  TextArea: TextArea,
  Hidden: Hidden
};